/* SecretMia — script del tema Shopify.
   Il carrello è quello di Shopify (Ajax API): /cart.js, /cart/add.js, /cart/change.js */
(() => {
const SM = window.SM || {routes: {}};
const colorName = c => c === 'bianco' ? 'Bianco' : 'Nero';

/* ---------- prezzi nel formato del negozio (es. "€{{amount_with_comma_separator}}") ---------- */
function money(cents) {
  const n = (cents || 0) / 100;
  const fmt = (dec, thou, digits = 2) => {
    const [i, d] = n.toFixed(digits).split('.');
    return i.replace(/\B(?=(\d{3})+(?!\d))/g, thou) + (d ? dec + d : '');
  };
  return (SM.moneyFormat || '€{{amount_with_comma_separator}}').replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => ({
    amount: fmt('.', ','),
    amount_no_decimals: fmt('.', ',', 0),
    amount_with_comma_separator: fmt(',', '.'),
    amount_no_decimals_with_comma_separator: fmt(',', '.', 0),
    amount_with_apostrophe_separator: fmt('.', "'")
  })[k] ?? fmt(',', '.'));
}

/* ---------- memoria locale (può non esserci: finestra privata, dati bloccati) ---------- */
const store = {
  get(key) { try { return localStorage.getItem(key); } catch (e) { return null; } },
  set(key, value) { try { localStorage.setItem(key, value); } catch (e) {} }
};

/* ---------- verifica 18+: ricordata sul dispositivo ---------- */
const age = document.getElementById('age');
if (age && store.get('secretmia-18') !== 'true') { age.hidden = false; document.body.classList.add('is-locked'); }
document.getElementById('age-yes')?.addEventListener('click', () => {
  store.set('secretmia-18', 'true');
  age.hidden = true;
  document.body.classList.remove('is-locked');
});

/* ---------- menu mobile ---------- */
const burger = document.getElementById('burger');
const mobileNav = document.getElementById('mobile-nav');
const setMenu = open => {
  mobileNav.classList.toggle('is-open', open);
  burger.setAttribute('aria-expanded', String(open));
};
burger?.addEventListener('click', () => setMenu(!mobileNav.classList.contains('is-open')));
mobileNav?.querySelectorAll('a').forEach(a => a.addEventListener('click', () => setMenu(false)));

/* ---------- reveal on scroll ---------- */
const io = new IntersectionObserver(entries => {
  entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }});
}, {threshold:.12, rootMargin:'0px 0px -60px'});
document.querySelectorAll('.reveal').forEach((el, i) => {
  el.style.transitionDelay = (i % 4) * 80 + 'ms';
  io.observe(el);
});

/* ---------- FAQ: una aperta alla volta per gruppo ---------- */
document.querySelectorAll('.faq').forEach(group => {
  group.querySelectorAll('details').forEach(d => d.addEventListener('toggle', () => {
    if (d.open) group.querySelectorAll('details').forEach(o => { if (o !== d) o.open = false; });
  }));
});

/* ---------- avviso in basso ---------- */
const toast = document.getElementById('toast');
let toastTimer;
function notify(text) {
  document.getElementById('toast-text').textContent = text;
  toast.classList.add('is-on');
  clearTimeout(toastTimer);
  toastTimer = setTimeout(() => toast.classList.remove('is-on'), 3500);
}

/* ==========================================================================
   CARRELLO SHOPIFY
   ========================================================================== */
async function api(url, body) {
  const res = await fetch(url, body ? {
    method: 'POST',
    headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
    body: JSON.stringify(body)
  } : {headers: {'Accept': 'application/json'}});
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.description || data.message || 'Errore del carrello');
  return data;
}
const getCart = () => api(SM.routes.cartJs);

const esc = s => String(s ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
const isExtra = item => item.handle === 'opzioni-extra';

function lineHTML(item) {
  const extra = isExtra(item);
  const img = item.image
    ? `<img class="media__img" src="${esc(item.image + (item.image.includes('?') ? '&' : '?') + 'width=200')}" alt="">`
    : '';
  const title = extra ? item.variant_title : item.product_title;
  const meta = extra
    ? `Extra${item.properties && item.properties.Per ? ' per ' + esc(item.properties.Per) : ''}`
    : esc(item.variant_title || '');
  return `
    <article class="cart-item${extra ? ' cart-item--extra' : ''}">
      <a class="media" href="${esc(item.url)}" tabindex="-1" aria-hidden="true">${img}</a>
      <div>
        <h3>${extra ? esc(title) : `<a href="${esc(item.url)}">${esc(title)}</a>`}</h3>
        <p class="cart-item__meta">${meta}</p>
        <div class="cart-item__row">
          <div class="qty">
            <button type="button" data-key="${esc(item.key)}" data-qty="${item.quantity - 1}" aria-label="Diminuisci">−</button>
            <span class="num">${item.quantity}</span>
            <button type="button" data-key="${esc(item.key)}" data-qty="${item.quantity + 1}" aria-label="Aumenta">+</button>
          </div>
          <button type="button" class="cart-item__remove" data-key="${esc(item.key)}" data-qty="0">Rimuovi</button>
        </div>
      </div>
      <span class="cart-item__price num">${money(item.final_line_price)}</span>
    </article>`;
}

function renderDrawer(cart) {
  const badge = document.getElementById('cart-count');
  badge.textContent = cart.item_count;
  badge.classList.toggle('is-on', cart.item_count > 0);
  document.getElementById('drawer-count').textContent = cart.item_count ? `(${cart.item_count})` : '';
  document.getElementById('drawer-items').innerHTML = cart.items.length
    ? cart.items.map(lineHTML).join('')
    : `<div class="drawer__empty"><p>Il carrello è vuoto. Non farmi aspettare 😏</p><a class="btn btn--ghost btn--sm" href="${esc(SM.routes.shop)}">Vai allo shop</a></div>`;
  document.getElementById('drawer-foot').hidden = !cart.items.length;
  document.getElementById('drawer-sub').textContent = money(cart.total_price);
}

/* più / meno / rimuovi: nel carrello laterale aggiorna al volo, nella pagina carrello ricarica */
document.addEventListener('click', async e => {
  const b = e.target.closest('[data-key]');
  if (!b) return;
  b.disabled = true;
  try {
    const cart = await api(SM.routes.cartChange, {id: b.dataset.key, quantity: Math.max(0, +b.dataset.qty)});
    if (document.getElementById('cart') && !b.closest('.drawer')) { location.reload(); return; }
    renderDrawer(cart);
  } catch (err) {
    notify(err.message);
    b.disabled = false;
  }
});

/* ---------- carrello laterale ---------- */
const drawer = document.getElementById('drawer');
let lastFocus = null;
function openDrawer(addedText) {
  const added = document.getElementById('drawer-added');
  added.hidden = !addedText;
  added.textContent = addedText || '';
  lastFocus = document.activeElement;
  drawer.classList.add('is-open');
  drawer.setAttribute('aria-hidden', 'false');
  document.body.classList.add('is-locked');
  drawer.querySelector('.drawer__close').focus({preventScroll:true});
}
function closeDrawer() {
  drawer.classList.remove('is-open');
  drawer.setAttribute('aria-hidden', 'true');
  document.body.classList.remove('is-locked');
  lastFocus?.focus({preventScroll:true});
}
drawer.addEventListener('click', e => { if (e.target.closest('[data-close]')) closeDrawer(); });
addEventListener('keydown', e => { if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer(); });
document.querySelector('.cart-link').addEventListener('click', async e => {
  if (document.getElementById('cart')) return;            // sulla pagina carrello resta un link normale
  e.preventDefault();
  try { renderDrawer(await getCart()); openDrawer(); } catch (err) { location.href = SM.routes.cart; }
});

async function addToCart(items, label, button) {
  if (button) button.disabled = true;
  try {
    await api(SM.routes.cartAdd, {items});
    renderDrawer(await getCart());
    openDrawer(`Nel carrello: ${label}. Ottima scelta 😏`);
  } catch (err) {
    notify(err.message);
  } finally {
    if (button) button.disabled = false;
  }
}

/* ---------- card prodotto: colore + aggiunta rapida ---------- */
/* i link alla scheda portano con sé il colore scelto (?colore=bianco) */
function linkColor(card, color) {
  card.querySelectorAll('[data-card-link]').forEach(a => {
    const u = new URL(a.href, location.href);
    if (color === 'bianco') u.searchParams.set('colore', 'bianco'); else u.searchParams.delete('colore');
    a.href = u.href;
  });
}
document.querySelectorAll('.product[data-variant-nero]').forEach(card => {
  card.querySelectorAll('.swatch').forEach(s => s.addEventListener('click', () => {
    card.querySelectorAll('.swatch').forEach(x => x.setAttribute('aria-pressed', String(x === s)));
    card.dataset.color = s.dataset.value;
    linkColor(card, s.dataset.value);
  }));
  const btn = card.querySelector('.quick-add');
  btn?.addEventListener('click', () => {
    const color = card.dataset.color;
    const id = +(card.dataset['variant' + colorName(color)] || card.dataset.variantNero);
    addToCart([{id, quantity: 1}], `${card.dataset.title} · ${colorName(color)}`, btn);
  });
});

/* ---------- scheda prodotto: colore, extra, quantità, totale ---------- */
const pdp = document.querySelector('.pdp');
if (pdp) {
  const media = pdp.querySelector('.pdp__media');
  const qty = document.getElementById('qty');
  const color = () => pdp.querySelector('input[name="colore"]:checked')?.value || 'nero';
  const count = () => Math.min(10, Math.max(1, +qty.value || 1));
  const extras = () => [...pdp.querySelectorAll('input[name="extra"]:checked')];
  const showTotal = () => {
    const base = +(pdp.dataset['price' + colorName(color())] || pdp.dataset.priceNero);
    const add = extras().reduce((s, c) => s + +c.dataset.price, 0);
    document.getElementById('pdp-total').textContent = money((base + add) * count());
  };
  pdp.querySelectorAll('input[name="colore"]').forEach(r => r.addEventListener('change', () => {
    media.dataset.color = r.value;
    document.getElementById('color-label').textContent = colorName(r.value);
    showTotal();
  }));
  pdp.querySelectorAll('[data-qty]').forEach(b => b.addEventListener('click', () => {
    qty.value = Math.min(10, Math.max(1, count() + +b.dataset.qty));
    showTotal();
  }));
  qty.addEventListener('input', showTotal);
  pdp.querySelectorAll('input[name="extra"]').forEach(c => c.addEventListener('change', showTotal));

  // arrivo da una card con il bianco scelto
  if (new URLSearchParams(location.search).get('colore') === 'bianco') {
    const r = pdp.querySelector('input[name="colore"][value="bianco"]');
    if (r) { r.checked = true; r.dispatchEvent(new Event('change')); }
  }

  const btn = document.getElementById('add-to-cart');
  btn.addEventListener('click', () => {
    const c = color();
    const n = count();
    const label = `${pdp.dataset.title} · ${colorName(c)}`;
    const id = +(pdp.dataset['variant' + colorName(c)] || pdp.dataset.variantNero);
    // gli extra finiscono nel carrello come righe collegate al paio
    const items = [{id, quantity: n}].concat(extras().map(x => ({
      id: +x.value, quantity: n, properties: {Per: label}
    })));
    addToCart(items, label, btn);
  });
}

/* ---------- carosello "Potrebbe piacerti" ---------- */
document.querySelectorAll('[data-carousel]').forEach(c => {
  const track = c.querySelector('.carousel__track');
  const nav = c.querySelector('.carousel__nav');
  if (!track || !nav || !track.firstElementChild) return;
  const [prev, next] = nav.querySelectorAll('button');
  const step = () => track.firstElementChild.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 20);
  const update = () => {
    const max = track.scrollWidth - track.clientWidth;
    nav.hidden = max <= 1;
    prev.disabled = track.scrollLeft <= 1;
    next.disabled = track.scrollLeft >= max - 1;
  };
  prev.addEventListener('click', () => track.scrollBy({left: -step()}));
  next.addEventListener('click', () => track.scrollBy({left: step()}));
  track.addEventListener('scroll', update, {passive:true});
  addEventListener('resize', update);
  update();
});

/* ---------- modulo richieste: controllo i campi, poi lo invia Shopify ---------- */
const form = document.getElementById('request-form');
if (form) {
  form.addEventListener('submit', e => {
    let ok = true;
    form.querySelectorAll('[required]').forEach(input => {
      const wrap = input.closest('.field, .check');
      const valid = input.type === 'checkbox' ? input.checked : input.value.trim() !== '' && input.checkValidity();
      wrap?.classList.toggle('is-invalid', !valid);
      if (!valid) ok = false;
    });
    if (!ok) {
      e.preventDefault();
      form.querySelector('.is-invalid input, .is-invalid select, .is-invalid textarea')?.focus();
    }
  });
  form.addEventListener('input', e => e.target.closest('.is-invalid')?.classList.remove('is-invalid'));
  if (form.querySelector('.form-done--show')) form.scrollIntoView({block: 'center'});
}

/* ---------- "Preferenze cookie": compare solo se il banner di Shopify è attivo ---------- */
const prefs = document.getElementById('cookie-prefs');
if (prefs) {
  const check = () => {
    if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
      prefs.hidden = false;
      return true;
    }
    return false;
  };
  if (!check()) addEventListener('load', () => setTimeout(check, 1500));
  prefs.addEventListener('click', () => window.privacyBanner?.showPreferences?.());
}
})();
